export default {
  countries: 'Countries',
  country: 'Country',
  add: 'Add country',
  update: 'Update country',
  details: 'Country details'
}
